/* ZUZU icons — Lucide-style, stroke-based, 1.5px default. */

export const ZZ_Icon = ({ d, size = 18, stroke = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth={stroke}
       strokeLinecap="round" strokeLinejoin="round" {...rest}>
    {d}
  </svg>
);

export const Arrow = ({ size = 14 }) => (
  <ZZ_Icon size={size} stroke={2} d={<><path d="M5 12h14M13 5l7 7-7 7" /></>} />
);
export const Eye = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" /><circle cx="12" cy="12" r="3" /></>} />
);
export const EyeOff = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" /><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" /></>} />
);
export const ArrowDown = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 5v14M5 12l7 7 7-7" /></>} />
);
export const ArrowUp = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 19V5M5 12l7-7 7 7" /></>} />
);
export const Chevron = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M9 6l6 6-6 6" />} />
);
export const ChevronLeft = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M15 6l-6 6 6 6" />} />
);
export const Check = ({ size = 16 }) => (
  <ZZ_Icon size={size} stroke={2} d={<path d="M4 12l5 5L20 6" />} />
);
export const X = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M6 6l12 12M6 18L18 6" />} />
);
export const Plus = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M12 5v14M5 12h14" />} />
);
export const Minus = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M5 12h14" />} />
);
export const Drag = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><circle cx="9" cy="6" r="0.8" fill="currentColor"/><circle cx="15" cy="6" r="0.8" fill="currentColor"/><circle cx="9" cy="12" r="0.8" fill="currentColor"/><circle cx="15" cy="12" r="0.8" fill="currentColor"/><circle cx="9" cy="18" r="0.8" fill="currentColor"/><circle cx="15" cy="18" r="0.8" fill="currentColor"/></>} />
);
export const Pause = ({ size = 14 }) => (
  <ZZ_Icon size={size} d={<><rect x="6" y="5" width="4" height="14" /><rect x="14" y="5" width="4" height="14" /></>} />
);
export const Play = ({ size = 14 }) => (
  <ZZ_Icon size={size} d={<path d="M6 5l13 7-13 7z" fill="currentColor" />} />
);
export const Bell = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></>} />
);
export const QR = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h3v3h-3zM18 14h3M14 18v3M18 21h3v-3"/></>} />
);
export const Cal = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></>} />
);
export const Layers = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 3 2 8l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></>} />
);
export const Home = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M3 11l9-8 9 8v9a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2v-9z"/></>} />
);
export const User = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><circle cx="12" cy="8" r="4"/><path d="M3 21a9 9 0 0 1 18 0"/></>} />
);
export const Settings = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3h0a1.6 1.6 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.6 1.6 0 0 0 1 1.5h0a1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8v0a1.6 1.6 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z"/></>} />
);
export const Lock = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>} />
);
export const Mail = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></>} />
);
export const Phone = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.9 9.7a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6A2 2 0 0 1 22 16.9z"/></>} />
);
export const Pin = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>} />
);
export const Clock = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></>} />
);
export const Snowflake = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19M9 6l3-3 3 3M9 18l3 3 3-3M6 9l-3 3 3 3M18 9l3 3-3 3"/></>} />
);
export const Flame = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 22c4.4 0 8-3.6 8-8 0-2.2-1.3-4-2.2-5C16 8 14 6 14 3c-1 1.5-3 3-5 5s-3 3.8-3 6c0 4.4 3.6 8 6 8z"/></>} />
);
export const Sparkle = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M12 2L13.5 8.5 20 10 13.5 11.5 12 18 10.5 11.5 4 10 10.5 8.5z"/><path d="M19 14v6M22 17h-6"/></>} />
);
export const Drop = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<path d="M12 2.5s-7 8-7 13a7 7 0 0 0 14 0c0-5-7-13-7-13z"/>} />
);
export const Wave = ({ size = 18 }) => (
  <ZZ_Icon size={size} d={<><path d="M2 12c2 0 2-3 4-3s2 3 4 3 2-3 4-3 2 3 4 3 2-3 4-3"/><path d="M2 17c2 0 2-3 4-3s2 3 4 3 2-3 4-3 2 3 4 3 2-3 4-3"/></>} />
);
export const Coin = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><circle cx="12" cy="12" r="9"/><path d="M12 7.4v9.2M9.6 9.6a2.4 2.1 0 0 1 4.8 0c0 2.5-4.8 1.4-4.8 3.9a2.4 2.1 0 0 0 4.8 0"/></>} />
);
export const Scan = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><path d="M3 12h18"/></>} />
);
// Two offset footprints — used in the InBody scan popup to show where feet go.
export const Footprints = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><ellipse cx="7" cy="15" rx="3" ry="5"/><circle cx="5.5" cy="8.5" r="1" fill="currentColor" stroke="none"/><circle cx="7" cy="7.3" r="1" fill="currentColor" stroke="none"/><circle cx="8.5" cy="8" r="1" fill="currentColor" stroke="none"/><ellipse cx="17" cy="9" rx="3" ry="5"/><circle cx="15.5" cy="16.5" r="1" fill="currentColor" stroke="none"/><circle cx="17" cy="17.3" r="1" fill="currentColor" stroke="none"/><circle cx="18.5" cy="17" r="1" fill="currentColor" stroke="none"/></>} />
);
// Handle bar with two thumb-press points — used to show where hands/thumbs go.
export const GripHandle = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><rect x="4" y="3.5" width="16" height="6" rx="3"/><path d="M8 9.5v3.3M16 9.5v3.3"/><circle cx="8" cy="16.2" r="2.3" fill="currentColor" stroke="none"/><circle cx="16" cy="16.2" r="2.3" fill="currentColor" stroke="none"/></>} />
);
export const Repeat = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<><path d="M17 2l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14M7 22l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>} />
);
// Chat bubble — used by the tab bars to open the "ask zuzu" widget.
export const Msg = ({ size = 16 }) => (
  <ZZ_Icon size={size} d={<path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.6-.8L3 21l1.8-5.9A8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5z"/>} />
);

// Wordmark — real glyph path data from the brand kit
const ZU_PAIR = (
  <>
    <path d="M58.0827 0H11.9168C5.33535 0 0 5.37259 0 12L0 12.75C0 19.3774 5.33536 24.75 11.9169 24.75H23.5874C24.9234 24.75 25.5839 26.3844 24.6275 27.3238L3.60934 47.968C1.31002 50.2265 0.0134183 53.3239 0.0134183 56.5583V57C0.0134183 63.6274 5.34877 69 11.9303 69H58.0602C64.6417 69 69.9771 63.6274 69.9771 57V56.25C69.9771 49.6226 64.6417 44.25 58.0602 44.25H46.2292C44.8938 44.25 44.233 42.617 45.1881 41.6772L66.412 20.792C68.7133 18.5275 70.0073 15.4222 70 12.1821L69.9995 11.9726C69.9845 5.35588 64.6535 0 58.0827 0Z" />
    <path d="M120.643 34.6589V14.6787C120.643 6.57187 127.214 0 135.321 0C143.428 0 150 6.57187 150 14.6787V55.187C149.066 62.4974 142.85 68.1466 135.321 68.1466C130.394 68.1466 126.03 65.7274 123.34 62.0065C118.322 66.3642 111.782 69 104.63 69C88.8179 69 76 56.1191 76 40.2297V14.8C76 6.62619 82.6262 0 90.8 0C98.9738 0 105.6 6.62619 105.6 14.8V34.6589C105.6 38.8128 108.967 42.1802 113.121 42.1802C117.275 42.1802 120.643 38.8128 120.643 34.6589Z" />
  </>
);
export const ZuzuWord = ({ width = 92 }) => (
  <svg width={width} viewBox="0 0 306 69" fill="currentColor" style={{ display: 'block' }} aria-label="zuzu">
    <g>{ZU_PAIR}</g>
    <g transform="translate(156, 0)">{ZU_PAIR}</g>
  </svg>
);
export const ZuzuStack = ({ size = 42 }) => (
  <svg width={size} viewBox="0 0 150 144" fill="currentColor" style={{ display: 'block' }} aria-label="zuzu">
    <g>{ZU_PAIR}</g>
    <g transform="translate(0, 75)">{ZU_PAIR}</g>
  </svg>
);
